import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getSleevesByUser } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class SleevesByUserContainer extends React.Component {
  componentDidMount() {
    const page = this.props.page || 1;
    const chimDir = this.props.chimDir || "";
    this.props.request(chimDir, page);
  }
  componentWillReceiveProps(nextProps) {
    const { page: nextPage, chimDir: nextChimDir } = nextProps;
    const { page, chimDir } = this.props;
    if (nextPage !== page || nextChimDir !== chimDir) {
      this.props.request(nextChimDir, nextPage);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    return render({ result, loading, failure });
  };
}

export default CreateContainer(getSleevesByUser, SleevesByUserContainer);
